var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureChatInviteActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.969,
    height: 16.948,
    viewBox: "0 0 22.969 16.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161542",
    "data-name": "Group 161542",
    transform: "translate(-3415.926 -602.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "link-svgrepo-com",
    d: "M12.327,14.218h1.555a3.109,3.109,0,1,0,0-6.218H12.327M6.886,11.109H13.1M7.664,8H6.109a3.109,3.109,0,1,0,0,6.218H7.664",
    transform: "translate(3421.154 601.315)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2682",
    "data-name": "Path 2682",
    d: "M3397.6,606.541c-1.844-.844-7.416-3.375-7.416-3.375l-7.5,3.375s.125,5.063,1.353,7.044,6.147,4.688,6.147,4.688",
    transform: "translate(34)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureChatInviteActiveIcon);
export default __webpack_public_path__ + "static/media/secure-chat-invite-active-icon.9c587b204b58ecf1d5c8f3cca7d2e063.svg";
export { ForwardRef as ReactComponent };